import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { openClose } from '@core/animations/animations';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { Observable } from 'rxjs';
import { ICON } from '@core/util/icon';
import { MissingFieldSection } from '../../services/validate-fct-data.service';
import { CostBreakdownComponent } from '../cost-breakdown/cost-breakdown.component';
import { KeyDatesModalComponent } from 'src/app/private/sale/home/key-dates-modal/key-dates-modal.component';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';
import { TitleInsuranceQuote } from '@models/title-insurance';
import { UrlService } from 'src/app/shared/services/url/url.service';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TestHooks } from './not-submitted.hooks';
import { DrawerService } from 'src/app/ui/drawer/drawer.service';

@UntilDestroy()
@Component({
	selector: 'app-fct-not-submitted',
	templateUrl: './not-submitted.component.html',
	animations: [openClose()],
	standalone: false,
})
export class FctNotSubmittedComponent implements OnInit {
	testHooks = TestHooks;
	public ICON = ICON;
	backUrlParams = { 'back-string': 'Title insurance' };
	keyDatesModalParams = { modal: 'keyDates' };
	public order;
	public error: string = null;
	public thirdPartyId: string;
	public missingQuoteFields = [];
	public propertyUrl: string;

	@Input() missing: MissingFieldSection[] = [];
	@Input() orderValid: boolean;
	@Input() isCommercial: boolean;
	@Input() invalidProperty: boolean;
	@Input() outOfOntario = false;

	@ViewSelectSnapshot(SelectedMatter.titleInsuranceQuote)
	quote: TitleInsuranceQuote;
	@SelectSnapshot(SelectedMatter.id) matterId: string;
	@Select(SelectedMatter.titleInsuranceThirdPartyId)
	thirdPartyId$: Observable<string>;

	@Output() openModal: EventEmitter<void> = new EventEmitter();
	@Output() cancelOrder: EventEmitter<void> = new EventEmitter();

	constructor(
		private navService: NavigationService,
		private dialog: MatDialog,
		private route: ActivatedRoute,
		private drawerService: DrawerService,
	) {}

	ngOnInit(): void {
		this.propertyUrl = UrlService.Matter_Property_Details(this.matterId);
	}

	cancel(): void {
		this.cancelOrder.emit();
	}

	_openModal() {
		this.openModal.emit();
	}

	showBreakdown() {
		this.dialog.open(CostBreakdownComponent);
	}

	openKeyDatesDrawer(event: Event) {
		event.preventDefault();

		this.drawerService.openDrawer(KeyDatesModalComponent, {
			size: 'md',
			title: 'Key Dates',
			noStyle: true,
		});
	}
}
